import LoginWithBackGroundImageContainer from '../../../../Componant/OtherPages/Authentication/LoginWithBackGroundImage/LoginWithBackGroundImage'

const LoginWithBackGroundImage = () => {
  return (
    <div className='page-body'>
      <LoginWithBackGroundImageContainer />
    </div>
  )
}

export default LoginWithBackGroundImage